module.exports = "/headshot_moray_mcleish.jpg?3a6aca";